import Vue from 'vue'
import "amfe-flexible"
import "reset-css"
import App from './App.vue'
import axios from 'axios'
import router from  './router'
import store from './store'

import { Button,Input,Image,Loading,Icon,Dialog, Select,Option, OptionGroup } from 'element-ui';

Vue.config.productionTip = false
Vue.prototype.axios=axios
Vue.prototype.$loading = Loading.service;

Vue.use(Loading.directive);
Vue.component(Button.name,Button)
Vue.component(Input.name,Input)
Vue.component(Image.name,Image)
Vue.component(Icon.name,Icon)
Vue.component(Dialog.name,Dialog )
Vue.component(Select.name,Select)
Vue.component(Option.name,Option)
Vue.component(OptionGroup.name,OptionGroup)
// Vue.component(Loading.name,Loading)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
